import React from 'react';
import { useSelector } from 'react-redux';
import { Option, useDropdown } from './useDropdown';
import { Shimmer } from '../../../../CommonComponents/OPL/Shimmer/Shimmer';
import { Select } from '../../../../CommonComponents/OPL/Select/Select/Select';
import { EXTERNAL_HOST } from '../../../../ConsumerArea/ConsumerAreaConstants';
import { externalHostSelector as selectExternalHostSelector } from '../../../../ConsumerArea/ConsumerAreaSelector';
import { Button } from '../../../../CommonComponents/OPL/Button/Button';
import { useRouteParams } from '../../hooks/useRouteParams';

interface Props {
  defaultSelected?: Option;
}

export const Dropdown = ({ defaultSelected }: Props) => {
  const externalHost = useSelector(selectExternalHostSelector);
  const { goalId, clientId } = useRouteParams();

  if (externalHost !== EXTERNAL_HOST.ELEMENT) {
    return <DropdownContent defaultSelected={defaultSelected} />;
  }

  if (!goalId) {
    return null;
  }

  return (
    <Button
      leftIcon="fas fa-chevron-left"
      onClick={() => {
        ADV.util.Router.go2('GoalsSummary', {
          clientId,
        });
      }}
    >
      Summary
    </Button>
  );
};

export const DropdownContent = ({ defaultSelected }: Props) => {
  const { isLoading, data, actions } = useDropdown();

  if (isLoading) {
    return <Shimmer width="100%" height={36} />;
  }

  if (!data) {
    return null;
  }

  const { value, options } = data;

  const { handleOnChange } = actions;

  return (
    <Select
      aria-label="Goals Selection"
      variant="icon"
      value={value || defaultSelected}
      options={options}
      onChange={handleOnChange}
    />
  );
};
